export const ROUTES = {
  HOME: '/',
  CATALOG: '/catalogo',
  CATEGORY: '/categoria/:slug',
  SUBCATEGORY: '/categoria/:slug/:subslug',
  PRODUCT: '/producto/:slug',
  SEARCH: '/buscar',
  BRANDS: '/marcas',
  BRAND: '/marca/:slug',
  PROMOTIONS: '/promociones',
  NEWS: '/novedades',
  CART: '/carrito',
  CHECKOUT: '/checkout',
  ORDER_CONFIRMATION: '/pedido/confirmacion/:orderId',
  ORDER_TRACKING: '/pedido/seguimiento/:orderId',
  LOGIN: '/ingresar',
  REGISTER: '/registro',
  FORGOT_PASSWORD: '/recuperar-contrasena',
  ACTIVATE_ACCOUNT: '/activar-cuenta',
  B2B_ACCESS_REQUEST: '/solicitar-acceso-mayorista',
  ACCOUNT: '/cuenta',
  PROFILE: '/cuenta/datos',
  ADDRESSES: '/cuenta/direcciones',
  ORDERS: '/cuenta/pedidos',
  FAVORITES: '/cuenta/favoritos',
  HISTORY: '/cuenta/historial',
  ADMIN: '/admin',
  ADMIN_LOGIN: '/admin/ingresar',
  ADMIN_AUTH_CALLBACK: '/admin/auth/callback',
  ADMIN_APPEARANCE: '/admin/apariencia',
  ADMIN_LAYOUT: '/admin/layout',
  ADMIN_NAVIGATION: '/admin/navegacion',
  ADMIN_CATALOG: '/admin/catalogo',
  ADMIN_FEATURES: '/admin/funcionalidades',
  STORE_UNAVAILABLE: '/tienda-no-disponible',
} as const;
